import {
    DTOCardFormField,
    FieldInCard,
} from 'app/types/form.types'
import {
    AdditionalFeesStatus,
    RangeType,
} from 'app/enums/label.enums'
import {
    AdditionalFeeValue,
} from '../AdditionalFee.types'

type FeesData = {
    ccy?: string,
    originalStatus?: string,
}
type Params = FeesData & {
    fees: {
        id: number,
    }[],
    exists: boolean,
    originalStatus?: string,
    editingAllowed: boolean,
    editingCommentAllowed: boolean,
    getAllowedValues: (param: Record<string, any>) => Record<string, string>
}

type AdditionalFeesFormFields = keyof AdditionalFeeValue

const additionalFeeComponents = ({
    ccy,
    fees,
    exists,
    originalStatus,
    editingAllowed,
    editingCommentAllowed,
    getAllowedValues,
}: Params) => {
    const feesRow: FieldInCard<AdditionalFeesFormFields> = {
        title: 'Fees',
        className: 'fees',
        fields: [{
            name: 'fees',
            componentName: 'Fees',
            currency: ccy,
            value: fees,
            disabled: editingAllowed,
            showSkyNetSpreadSheet: true,
            labelKey: 'FEES',
        }],
    }

    const defaultFields: DTOCardFormField<AdditionalFeesFormFields>[] = [{
        title: 'General',
        className: 'general',
        fields: [
            {
                id: 'column1',
                fields: [{
                    name: 'additionalFeesStatus',
                    originalStatus,
                    componentName: 'StatusTransitionSelector',
                    useDropdown: true,
                    allowedValues: getAllowedValues(AdditionalFeesStatus),
                    disabled: true,
                    labelKey: 'STATUS',
                }],
            },
            {
                id: 'column2',
                fields: [
                    {
                        name: 'validFrom',
                        componentName: 'DateSelect',
                        disabled: editingAllowed,
                        required: true,
                        labelKey: 'VALID_FROM',
                    },
                    {
                        name: 'validTo',
                        componentName: 'DateSelect',
                        disabled: editingAllowed,
                        required: true,
                        labelKey: 'VALID_TO',
                    },
                    {
                        name: 'requiresManualBillingReview',
                        componentName: 'Checkbox',
                        disabled: editingAllowed,
                        labelKey: 'REQUIRES_MANUAL_BILLING_REVIEW',
                    },
                ],
            },
            {
                id: 'column3',
                fields: [
                    {
                        name: 'cancellationFeeTimeline',
                        componentName: 'IntegerInput',
                        disabled: editingAllowed,
                        required: true,
                        labelKey: 'CANCELLATION_DAYS',
                    },
                    {
                        name: 'cancellationDaysType',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(RangeType),
                        useDropdown: true,
                        disabled: editingAllowed,
                        required: true,
                        labelKey: 'CANCELLATION_DAYS_TYPE',
                    },
                ],
            },
            {
                id: 'column4',
                className: 'commentColumn',
                fields: [{
                    name: 'comment',
                    componentName: 'LongText',
                    disabled: editingCommentAllowed && editingAllowed,
                    labelKey: 'COMMENT',
                }],
            },
        ],
    }]

    return exists ? [
        ...defaultFields,
        feesRow,
    ] : defaultFields
}

export default additionalFeeComponents
